export { default } from './AuditPanelSubtitle';
